'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserStaffStamp = require('./components/UserStaffStamp.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserStaffStamp).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-staff-stamp/lib/index.js
// module id = 1559
// module chunks = 1